import { putBlock } from "../service/putBlock"
import convertAmountInCents from "../utils/amountInCents"
import { TIME_RESULT } from "../utils/notifications/time"
import { toastUpdate } from "../utils/notifications/toast"
import { IProduct } from "../views/ecommerce/products/interfaces"

export const editProduct = async (
    values: any, 
    selectedProduct: IProduct
): Promise<{
    isError: boolean,
    block: any
}> => {
    let amount = convertAmountInCents(values.amount).toString()

    const { isError, block } = await putBlock("/branch/products", {
        id: selectedProduct.id,
        description: values.description,
        active: true,
        amount: amount,
        groupId: selectedProduct.groupId ?? values.group
    })

    if(isError) {
        toastUpdate("updateProduct",
            "error",
            TIME_RESULT,
            "Houve um problema ao editar o produto, entre em contato com o suporte."
        )
    }

    {
        toastUpdate("updateProduct",
            "success",
            TIME_RESULT,
            "Porduto atualizado!"
        )
    }

    return {
        isError: isError,
        block: block
    }
}